export default __webpack_public_path__ + "static/media/experience.0a61c510.webp";